import Vue from 'vue'
import Vuex from 'vuex'
import workspace from './workspace/index'
import imageEditor from './image-editor/index'
import audioEditor from './audio-editor/index'
import videoEditor from './video-editor/index'
import download from '@pt/store/pt/download'
import creative from './creative/index'
import config from '@pt/store/config'
import user from '@pt/store/user'
import getters from './getters'
import permission from './permission'
import uploader from './uploader'
import assets from './assets'
import ivTimeline from './interactive-video/timeline/index'
import ivBrain from './interactive-video/brain/index'
import ivCopyPaste from './interactive-video/copy-paste/index'
import estimateLimit from './estimate-limit/index.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    workspace,
    config,
    imageEditor,
    audioEditor,
    videoEditor,
    download,
    creative,
    user,
    permission,
    uploader,
    assets,
    ivTimeline,
    ivBrain,
    ivCopyPaste,
    estimateLimit,
  },
  getters,
})
